import {isLoggedIn} from "./guards";

export default [
    {
        path: '/docu/api',
        name: 'docu.api',
        component: () => import('../applications/ApiDocu/Ui.vue'),
        beforeEnter: isLoggedIn,
    }
]